import { toLocaleString } from "@circle-react/helpers/number";
import { useCreditBalance } from "@circle-react/hooks/useCreditBalance";
import { Alert } from "@circleco/compass/components/Alert";

import { t } from "@/i18n-js/instance";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";

export const TrialCreditsBanner = () => {
  const { isCommunityOnTrial } = usePlanStatus();
  const { data } = useCreditBalance({ enabled: isCommunityOnTrial });

  // Render only once the server-resolved amount is known, so a coupon community
  // never sees the standard 6,500 while loading or after a failed request.
  const trialConversionCredits = data?.trial_conversion_allotment_credits;
  if (!isCommunityOnTrial || trialConversionCredits == null) {
    return null;
  }

  const credits = toLocaleString(trialConversionCredits);
  const titleKey = data?.trial_conversion_credits_overridden
    ? "trial_credits_banner.promotion_title"
    : "trial_credits_banner.title";

  return (
    <Alert
      variant="info"
      layout="horizontal"
      icon="sparkle-filled"
      iconColor="info"
      title={t(titleKey, { credits })}
      description={t("trial_credits_banner.description", { credits })}
    />
  );
};
